import { Box, styled, LinearProgress, linearProgressClasses } from '@mui/material';
import React from 'react';

const Bar = styled(Box)(({ theme }) => ({
    width: '100%',
    [`.${linearProgressClasses.root}`]: {
        height: 12,
        [`.${linearProgressClasses.bar}`]: {
            backgroundColor: theme.palette.warning.main,
        },
    },
}));
interface ProgressBarProps {
    value: number;
}

export const ProgressBar: React.FunctionComponent<ProgressBarProps> = ({ value }) => {
    return (
        <Bar>
            <LinearProgress variant="determinate" value={value} />
        </Bar>
    );
};
